import styled from 'styled-components';

const Title = styled.h1`
  ${({ theme }) => theme.typograph.titleHeadline}
  margin-bottom: 16px;
  text-transform: uppercase;
`;

const Description = styled.h2`
  ${({ theme }) => theme.typograph.paragraphRegular}
  white-space: pre-wrap;
  margin-bottom: 32px;
`;

export {
  Title,
  Description,
};
